<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs v-model="selectedTab" align-tabs="start" color="darkGreen" @update:modelValue="initUsers()">
                    <v-tab :class="{'font-weight-black': selectedTab == institute.id}" v-for="institute in instituteData" :key="institute.id" :value="institute.id">
                        {{ institute.abbrev }}
                    </v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="programFilter"
                    :items="programOptions"
                    label="Filter by Program"
                    variant="outlined"
                    dense
                    hide-details
                    density="comfortable"
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col cols="12" md="2">
                <v-select
                    v-model="termFilter"
                    :items="termOptions"
                    label="Filter by Term"
                    variant="outlined"
                    dense
                    hide-details
                    density="comfortable"
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col cols="12" md="2">
                <v-select
                    v-model="examDayFilter"
                    :items="examDayOptions"
                    label="Filter by Exam Day"
                    variant="outlined"
                    dense
                    hide-details
                    density="comfortable"
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="filteredData"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.faculty_name="{ item }">
                                <span>{{ item.file.submittedBy.fname }} {{ item.file.submittedBy.lname }}</span>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:item.number_of_copies="{ item }">
                                <span>{{ item.file.number_of_copies || '---' }}</span>
                            </template>
                            <template v-slot:item.is_printed="{ item }">
                                <v-chip v-if="item.file.is_printed" color="green" size="small"> {{ formatDate(item.file.printed_date) }} <v-icon color="green">mdi-check</v-icon></v-chip>
                                <v-icon v-if="item.file.is_printed == false" color="red">mdi-close</v-icon>
                            </template>
                            <template v-slot:item.exam_day="{ item }">
                                <span>{{ item.file.exam_day || '---' }}</span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn @click="showViewDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <ViewApprovedCompliancesForDirector ref="ViewApprovedCompliancesForDirector" @refresh="initUsers()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import ViewApprovedCompliancesForDirector from '../Dialogs/ViewApprovedCompliancesForDirector.vue';


export default defineComponent({
    components: {
        ViewApprovedCompliancesForDirector
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            programFilter: 'All',
            termFilter: 'All',
            examDayFilter: 'All',
            headers: [
                { title: 'Submitted By', align: 'start', sortable: true, key: 'faculty_name' },
                { title: 'Term', align: 'start', sortable: true, key: 'term.name' },
                { title: 'Course Code', align: 'start', sortable: true, key: 'facultyLoad.code' },
                { title: 'Program/Department', align: 'start', sortable: true, key: 'file.reviewersDepartment.abbrev' },
                // { title: 'Date Submitted', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'No. of Copies', align: 'start', sortable: true, key: 'number_of_copies' },
                { title: 'Is Printed', align: 'start', sortable: true, key: 'is_printed' },
                { title: 'Exam Day', align: 'start', sortable: true, key: 'exam_day' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
            instituteData: [],
            selectedTab: 0,
        }
    },
    computed: {
        filteredData() {
            let filtered = this.data;
            if (this.programFilter && this.programFilter !== 'All') {
                filtered = filtered.filter(item => {
                    if (item.file && item.file.reviewersDepartment && item.file.reviewersDepartment.abbrev) {
                        return item.file.reviewersDepartment.abbrev === this.programFilter;
                    }
                    return false;
                });
            }
            if (this.termFilter && this.termFilter !== 'All') {
                filtered = filtered.filter(item => {
                    if (item.term && item.term.name) {
                        return item.term.name === this.termFilter;
                    }
                    return false;
                });
            }
            if (this.examDayFilter && this.examDayFilter !== 'All') {
                filtered = filtered.filter(item => {
                    if (item.file && item.file.exam_day) {
                        return item.file.exam_day === this.examDayFilter;
                    }
                    return false;
                });
            }
            return filtered;
        },
        programOptions() {
            const abbrevs = this.data.map(item => {
                if (item.file && item.file.reviewersDepartment && item.file.reviewersDepartment.abbrev) {
                    return item.file.reviewersDepartment.abbrev;
                }
                return null;
            }).filter(Boolean);
            const uniqueAbbrevs = [...new Set(abbrevs)];
            return ['All', ...uniqueAbbrevs];
        },
        termOptions() {
            const terms = this.data.map(item => {
                if (item.term && item.term.name) {
                    return item.term.name;
                }
                return null;
            }).filter(Boolean);
            const uniqueTerms = [...new Set(terms)];
            return ['All', ...uniqueTerms];
        },
        examDayOptions() {
            const days = this.data.map(item => {
                if (item.file && item.file.exam_day) {
                    return item.file.exam_day;
                }
                return null;
            }).filter(Boolean);
            const uniqueDays = [...new Set(days)];
            return ['All', ...uniqueDays];
        }
    },
    methods: {
        async init(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstituteAndExternalCampus')
            .then(res => {
                this.instituteData = res.data
                this.selectedTab = this.instituteData[0].id
            });

            this.initUsers()
        },
        async initUsers(){
            this.loading = true
            const res = await this.axiosCall('/compliance-upload-details/findAllApprovedTQandTOSByInstituteAndSemester/' + this.selectedTab + '/' + this.$store.state.semester_schoolyear.id, 'get', true)
            if(res){
                this.loading = false
                this.data = res.data
            }
        },
        showViewDialog(data){
            this.$refs.ViewApprovedCompliancesForDirector.initView(data)
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>